interface FilterType {
    filter_name: string,
    filter_slug: string,
    display_order: number,
    sport_name: string
}

export const filtersConfig:Record<string, Array<FilterType>> = {
    'americanfootball': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'Moneyline',
            'filter_slug': 'moneyline',
            'display_order': 3,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'Spread',
            'filter_slug': 'spread',
            'display_order': 4,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'Points',
            'filter_slug': 'points',
            'display_order': 5,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'Player',
            'filter_slug': 'player',
            'display_order': 6,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'Team',
            'filter_slug': 'team',
            'display_order': 7,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'Match',
            'filter_slug': 'match',
            'display_order': 8,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'Half',
            'filter_slug': 'half',
            'display_order': 9,
            'sport_name': 'americanfootball'
        },
        {
            'filter_name': 'Quarters',
            'filter_slug': 'quarters',
            'display_order': 10,
            'sport_name': 'americanfootball'
        }
    ],
    'basketball': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'basketball'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'basketball'
        },
        {
            'filter_name': 'Totals',
            'filter_slug': 'totals',
            'display_order': 3,
            'sport_name': 'basketball'
        },
        {
            'filter_name': 'Quarter',
            'filter_slug': 'quarter',
            'display_order': 4,
            'sport_name': 'basketball'
        },
        {
            'filter_name': 'Half',
            'filter_slug': 'half',
            'display_order': 5,
            'sport_name': 'basketball'
        },
        {
            'filter_name': 'Handicap',
            'filter_slug': 'handicap',
            'display_order': 6,
            'sport_name': 'basketball'
        },
        {
            'filter_name': 'Match',
            'filter_slug': 'match',
            'display_order': 7,
            'sport_name': 'basketball'
        }
    ],
    'baseball': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'baseball'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'baseball'
        },
        {
            'filter_name': 'Totals',
            'filter_slug': 'totals',
            'display_order': 3,
            'sport_name': 'baseball'
        },
        {
            'filter_name': 'Innings',
            'filter_slug': 'innings',
            'display_order': 4,
            'sport_name': 'baseball'
        },
        {
            'filter_name': 'Handicaps',
            'filter_slug': 'handicaps',
            'display_order': 5,
            'sport_name': 'baseball'
        },
        {
            'filter_name': 'Match',
            'filter_slug': 'match',
            'display_order': 6,
            'sport_name': 'baseball'
        }
    ],
    'cricket': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'cricket'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'cricket'
        },
        {
            'filter_name': 'Wickets',
            'filter_slug': 'wickets',
            'display_order': 3,
            'sport_name': 'cricket'
        },
        {
            'filter_name': 'Innings',
            'filter_slug': 'innings',
            'display_order': 4,
            'sport_name': 'cricket'
        },
        {
            'filter_name': 'Run',
            'filter_slug': 'run',
            'display_order': 5,
            'sport_name': 'cricket'
        },
        {
            'filter_name': 'Player',
            'filter_slug': 'player',
            'display_order': 6,
            'sport_name': 'cricket'
        },
        {
            'filter_name': 'Match',
            'filter_slug': 'match',
            'display_order': 7,
            'sport_name': 'cricket'
        },
        {
            'filter_name': 'Specials',
            'filter_slug': 'specials',
            'display_order': 8,
            'sport_name': 'cricket'
        }
    ],
    'football': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'football'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'football'
        },
        {
            'filter_name': 'Goals',
            'filter_slug': 'goals',
            'display_order': 3,
            'sport_name': 'football'
        },
        {
            'filter_name': 'Goalscorers',
            'filter_slug': 'goalscorers',
            'display_order': 4,
            'sport_name': 'football'
        },
        {
            'filter_name': 'Half And Period',
            'filter_slug': 'half_and_period',
            'display_order': 5,
            'sport_name': 'football'
        },
        {
            'filter_name': 'Handicap',
            'filter_slug': 'handicap',
            'display_order': 6,
            'sport_name': 'football'
        },
        {
            'filter_name': 'Corners',
            'filter_slug': 'corners',
            'display_order': 7,
            'sport_name': 'football'
        },
        {
            'filter_name': 'Cards & Penalties',
            'filter_slug': 'cards_&_penalties',
            'display_order': 8,
            'sport_name': 'football'
        },
        {
            'filter_name': '4-4-2',
            'filter_slug': '4-4-2',
            'display_order': 9,
            'sport_name': 'football'
        }
    ],
    'icehockey': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'icehockey'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'icehockey'
        },
        {
            'filter_name': 'Totals',
            'filter_slug': 'totals',
            'display_order': 3,
            'sport_name': 'icehockey'
        },
        {
            'filter_name': 'Handicaps',
            'filter_slug': 'handicaps',
            'display_order': 4,
            'sport_name': 'icehockey'
        },
        {
            'filter_name': 'Goals',
            'filter_slug': 'goals',
            'display_order': 5,
            'sport_name': 'icehockey'
        },
        {
            'filter_name': 'Period',
            'filter_slug': 'period',
            'display_order': 6,
            'sport_name': 'icehockey'
        },
        {
            'filter_name': 'Match',
            'filter_slug': 'match',
            'display_order': 7,
            'sport_name': 'icehockey'
        }
    ],
    'rugbyleague': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'rugbyleague'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'rugbyleague'
        },
        {
            'filter_name': 'Handicaps',
            'filter_slug': 'handicaps',
            'display_order': 3,
            'sport_name': 'rugbyleague'
        },
        {
            'filter_name': 'Points',
            'filter_slug': 'points',
            'display_order': 4,
            'sport_name': 'rugbyleague'
        },
        {
            'filter_name': 'Player',
            'filter_slug': 'player',
            'display_order': 5,
            'sport_name': 'rugbyleague'
        },
        {
            'filter_name': 'Team',
            'filter_slug': 'team',
            'display_order': 6,
            'sport_name': 'rugbyleague'
        },
        {
            'filter_name': 'Match',
            'filter_slug': 'match',
            'display_order': 7,
            'sport_name': 'rugbyleague'
        },
        {
            'filter_name': 'Half',
            'filter_slug': 'half',
            'display_order': 8,
            'sport_name': 'rugbyleague'
        }
    ],
    'tennis': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'tennis'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'tennis'
        },
        {
            'filter_name': 'Match',
            'filter_slug': 'match',
            'display_order': 3,
            'sport_name': 'tennis'
        },
        {
            'filter_name': 'Set',
            'filter_slug': 'set',
            'display_order': 4,
            'sport_name': 'tennis'
        },
        {
            'filter_name': 'Handicaps',
            'filter_slug': 'handicaps',
            'display_order': 5,
            'sport_name': 'tennis'
        },
        {
            'filter_name': 'Player',
            'filter_slug': 'player',
            'display_order': 6,
            'sport_name': 'tennis'
        },
        {
            'filter_name': 'Tie Break',
            'filter_slug': 'tie_break',
            'display_order': 7,
            'sport_name': 'tennis'
        }
    ],
    'rugbyunion': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'rugbyunion'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'rugbyunion'
        },
        {
            'filter_name': 'Handicaps',
            'filter_slug': 'handicaps',
            'display_order': 3,
            'sport_name': 'rugbyunion'
        },
        {
            'filter_name': 'Points',
            'filter_slug': 'points',
            'display_order': 4,
            'sport_name': 'rugbyunion'
        },
        {
            'filter_name': 'Player',
            'filter_slug': 'player',
            'display_order': 5,
            'sport_name': 'rugbyunion'
        },
        {
            'filter_name': 'Team',
            'filter_slug': 'team',
            'display_order': 6,
            'sport_name': 'rugbyunion'
        },
        {
            'filter_name': 'Match',
            'filter_slug': 'match',
            'display_order': 7,
            'sport_name': 'rugbyunion'
        },
        {
            'filter_name': 'Half',
            'filter_slug': 'half',
            'display_order': 8,
            'sport_name': 'rugbyunion'
        }
    ],
    'golf': [
        {
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 1,
            'sport_name': 'golf'
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 2,
            'sport_name': 'golf'
        },
        {
            'filter_name': 'Tournament Winner',
            'filter_slug': 'tournament_winner',
            'display_order': 3,
            'sport_name': 'golf'
        },
        {
            'filter_name': 'Round Leader',
            'filter_slug': 'round_leader',
            'display_order': 4,
            'sport_name': 'golf'
        },
        {
            'filter_name': 'Top Finishes',
            'filter_slug': 'top_finishes',
            'display_order': 5,
            'sport_name': 'golf'
        },
        {
            'filter_name': 'Match Ups',
            'filter_slug': 'match_ups',
            'display_order': 6,
            'sport_name': 'golf'
        },
        {
            'filter_name': 'Group Betting',
            'filter_slug': 'group_betting',
            'display_order': 7,
            'sport_name': 'golf'
        },
        {
            'filter_name': '2/3 Balls',
            'filter_slug': '2/3_balls',
            'display_order': 8,
            'sport_name': 'golf'
        },
        {
            'filter_name': 'Top Nationalities',
            'filter_slug': 'topnatio_nalities',
            'display_order': 9,
            'sport_name': 'golf'
        },
        {
            'filter_name': 'Speciality markets',
            'filter_slug': 'speciality_markets',
            'display_order': 10,
            'sport_name': 'golf'
        }
    ]

};
